import React from 'react';
import Inline from './inline';
export default function Paragraph(_ref) {
  var children = _ref.children,
    dataAttributes = _ref.dataAttributes;
  return /*#__PURE__*/React.createElement("p", dataAttributes, /*#__PURE__*/React.createElement(Inline, null, children));
}